import React from 'react';
import PropTypes from "prop-types";
import { dataAttribsForEl, formatClassName } from '../../Util';

export default class CardMediaBox extends React.Component {
  static propTypes = {
    hasLabel: PropTypes.bool,
    type: PropTypes.string,
    mediaContent: PropTypes.node,
    mediaDataAttributes: PropTypes.object,
    mediaSize: PropTypes.oneOf(['small', 'large', 'full']),
    mediaPosition: PropTypes.oneOf(['left', 'right', 'center']),
    mediaBackground: PropTypes.oneOf(['white', 'gray', 'light']),
    mediaUrl: PropTypes.string
  };

  static defaultProps = {
    mediaDataAttributes: {},
    mediaSize: 'large',
    mediaPosition: 'left',
    mediaBackground: 'white',
    type: 'wide'
  }

  getMediaClasses = () => {
    const { type, mediaSize, mediaPosition, mediaBackground, hasLabel } = this.props;
    return formatClassName([
      'card-media',
      `card-media-${type}`,
      `card-media-${mediaSize}`,
      `card-media-${mediaPosition}`,
      `card-media-${mediaBackground}`,
      { 'has-label': hasLabel }
    ])
  }

  renderMedia = () => {
    const { mediaUrl, mediaContent } = this.props;
    if (mediaContent) {
      return mediaContent;
    } else {
      return (
        <img src={mediaUrl} />
      )
    }
  }

  render() {
    const { mediaDataAttributes: { context, optionalAttributes } } = this.props;

    const mediaClasses = this.getMediaClasses();
    const dataAttributes = dataAttribsForEl(context, optionalAttributes);

    return (
      <div className={mediaClasses} {...dataAttributes}>
        {this.renderMedia()}
      </div>
    )
  }
}
